import type { SVGProps } from 'react';
const DawnFlagUZ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-UZ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-UZ_svg__a)">
      <path fill="#04AAC8" d="M0 5.333h22V0H0z" />
      <path fill="#23C840" d="M0 16h22v-5.333H0z" />
      <path
        fill="#fff"
        d="M3.667 4.267c.323 0 .624-.1.873-.27L4.453 4c-.723 0-1.31-.597-1.31-1.333a1.32 1.32 0 0 1 1.397-1.33c-.25-.171-.55-.27-.873-.27-.868 0-1.571.716-1.571 1.6 0 .883.703 1.6 1.571 1.6m2.62-.534a.53.53 0 0 1-.525.534.53.53 0 0 1-.523-.534c0-.294.234-.533.523-.533s.524.239.524.533m1.57-1.6c.29 0 .524-.238.524-.533a.53.53 0 0 0-.523-.533.53.53 0 0 0-.524.533c0 .295.234.533.524.533m2.62-.533a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.235-.533.524-.533s.524.238.524.533m-.524 2.667c.29 0 .524-.24.524-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.534.524.534M8.38 3.733a.53.53 0 0 1-.523.534.53.53 0 0 1-.524-.534c0-.294.234-.533.524-.533.289 0 .523.239.523.533"
      />
    </g>
  </svg>
);
export default DawnFlagUZ;
